"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var status_indicator_icon_component_1 = __importDefault(require("./status-indicator-icon.component"));
var StaticPump = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n"], ["\n  width: 32px;\n  height: 32px;\n"])));
exports.StaticPumpIcon = function (_a) {
    var state = _a.state, theme = _a.theme;
    return (React.createElement(React.Fragment, null,
        React.createElement(status_indicator_icon_component_1.default, { state: state, theme: theme }),
        React.createElement(StaticPump, null,
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" },
                React.createElement("path", { d: "M16 2a13.89 13.89 0 00-7.23 2 1 1 0 00-.43.26A14 14 0 1016 2zm11.94 12.81L11.11 5.05A11.88 11.88 0 0116 4a12 12 0 0111.94 10.81zM4 16a12 12 0 015.1-9.8L26 16 9.56 26.11A12 12 0 014 16zm12 12a11.85 11.85 0 01-4.35-.83l16.29-10A12 12 0 0116 28z" })))));
};
exports.default = exports.StaticPumpIcon;
var templateObject_1;
//# sourceMappingURL=static-pump-icon.component.js.map